import { Grid, TextField } from "@mui/material";
import React from "react";
import GoogleAddressSelect from "../../carecoordinator/patient/GoogleAddressSelect";
import { MuiTelInput } from "mui-tel-input";
import FacilityTypeSelect from "./FacilityTypeSelect";

const AddEditFacilityForm = ({
  facilityDetails,
  setFacilityDetails,
  errors,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFacilityDetails((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={12} item>
          <TextField
            required
            fullWidth
            value={facilityDetails?.facilityName}
            name="facilityName"
            label="Facility Name"
            variant="outlined"
            error={errors?.facilityName}
            helperText={errors?.facilityName}
            onChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <FacilityTypeSelect
            facilityDetails={facilityDetails}
            handleChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <MuiTelInput
            fullWidth
            defaultCountry="US"
            value={facilityDetails?.facilityPhone}
            label="Telephone"
            forceCallingCode
            onChange={(value) =>
              setFacilityDetails((prev) => ({
                ...prev,
                facilityPhone: value,
              }))
            }
          />
        </Grid>
        <Grid xs={12} item>
          <GoogleAddressSelect
            address={facilityDetails?.facilityCompleteAddress}
            setData={setFacilityDetails}
            required={true}
            errors={errors}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            value={facilityDetails?.facilityComments}
            multiline
            rows={2}
            name="comments"
            label="Comments"
            variant="outlined"
            onChange={handleChange}
            sx={{ height: "auto", "& .MuiInputBase-root": { height: "auto" } }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AddEditFacilityForm;
